import { render, staticRenderFns } from "./ClientSearchBarComponent.vue?vue&type=template&id=68ac4836"
import script from "./ClientSearchBarComponent.vue?vue&type=script&lang=js"
export * from "./ClientSearchBarComponent.vue?vue&type=script&lang=js"
import style0 from "./ClientSearchBarComponent.vue?vue&type=style&index=0&id=68ac4836&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports